/**
 * Device UA helper extracted from getAxiosConfig.
 *
 * persistedData (a reducer) used to import getUserAgent from getAxiosConfig, which
 * imported the Redux store and persistedData again — closing the circular import
 * that crashed prod after minify. This file only needs constants; it is safe for
 * reducers to import at module load.
 */
import { USER_AGENT_STRING } from "./constants";

export const getUserAgent = () => {
  if (typeof window === "undefined") {
    return "server-render";
  }
  return /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
    window?.navigator.userAgent
  )
    ? USER_AGENT_STRING.ANDROID
    : USER_AGENT_STRING.IOS;
};
